import { ModalProps } from 'antd';
import { SModal } from './Modal.styles';

export const Modal = ({ ...props }: ModalProps) => {
  return <SModal {...props} />;
};
